import { axiosAuth, axiosPublic } from "./axiosApi";
import { API_PATHS } from "./constants";

export const login = async (data) =>
  axiosPublic.post(API_PATHS.AUTH_LOGIN, data);
export const registration = async (data) =>
  axiosPublic.post(API_PATHS.AUTH_REGISTER, data);
export const logout = async () => {
  try {
    const response = await axiosAuth.post(API_PATHS.AUTH_LOGOUT);
    console.log("Logout response:", response);
    return response;
  } catch (error) {
    console.error("Logout error:", error);
    throw error;
  }
};

export const authVerify = async (id) =>
  axiosPublic.get(`${API_PATHS.AUTH_VERIFICATION}/${id}`);
